import type { ReactNode } from 'react';

import { E_SECTION_MODE, subsectionConfig } from '@common/configs';
import type { ISectionComponentProps } from '@components/ReportContent/types';
import { formatSectionId } from '@components/Sidebar/helpers';
import Subsection from '@components/Subsection';

const GenericSection = (props: ISectionComponentProps) => {
  const { sectionData, slideRefs, visibleSubSections } = props;
  const mode = subsectionConfig[sectionData.id] ?? E_SECTION_MODE.SINGLE;

  const renderSubsection = (subsectionId: string, title: string, content: ReactNode) => {
    const refElement = slideRefs.get(subsectionId);
    const isVisible = visibleSubSections.has(subsectionId);
    return (
      <Subsection
        key={subsectionId}
        id={subsectionId}
        title={title}
        content={content}
        refElement={refElement}
        isVisible={isVisible}
      />
    );
  };

  // Multi-mode → one subsection per key/value
  if (mode === E_SECTION_MODE.MULTI && 'data' in sectionData && sectionData.data) {
    return Object.entries(sectionData.data).map(([key, value]) => {
      const multiSubsectionId = `${sectionData.id}::${key}`;
      return renderSubsection(multiSubsectionId, `${formatSectionId(sectionData.id)} – ${key}`, `${value}`);
    });
  }

  // Single-mode → one subsection for the whole section
  const singleSubsectionId = sectionData.id;
  const singleSlideContent =
    'data' in sectionData && sectionData.data
      ? Object.entries(sectionData.data).map(([key, value]) => {
          return (
            <div key={key}>
              <strong>{key}:</strong> {value}
            </div>
          );
        })
      : 'Placeholder';

  return renderSubsection(singleSubsectionId, formatSectionId(sectionData.id), singleSlideContent);
};

export default GenericSection;
